import { render, staticRenderFns } from "./UnvisitedAccountSubList.vue?vue&type=template&id=71980c8c"
import script from "./UnvisitedAccountSubList.vue?vue&type=script&lang=js"
export * from "./UnvisitedAccountSubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports